import { graphql } from "../graphql";

export const ClaimOnCourseMeasurementByPhoneMutation = graphql(/* GraphQL */ `
  mutation claimOnCourseMeasurementByPhone(
    $measurementId: String!
    $phoneNumber: String!
    $introText: String
  ) {
    claimOnCourseMeasurementByPhone(
      input: {
        measurementId: $measurementId
        phoneNumber: $phoneNumber
        introText: $introText
      }
    ) {
      appMutationResult {
        isSuccess
      }
    }
  }
`);
